<tax-modal-header>kkm.action.deregister.title</tax-modal-header>

<tax-modal-content data-qa-block="deregister-modal">
  <div class="deregister-subtitle">
    <svg-icon key="info"></svg-icon>
    <span class="bold-text" translate data-qa="instruction-header"
      >kkm.action.deregister.subtitle</span
    >
  </div>
  <div class="deregister-text">
    <p translate data-qa="step-1">kkm.action.deregister.description.one</p>
    <p translate data-qa="step-2">kkm.action.deregister.description.two</p>
    <p translate data-qa="step-3">kkm.action.deregister.description.three</p>
  </div>
</tax-modal-content>

<tax-modal-footer>
  <button
    data-qa-link="deregister-kkm"
    class="button_blue ui-kit-align-right"
    (click)="continue()"
    translate
  >
    button.continue
  </button>
</tax-modal-footer>
